export default __webpack_public_path__ + "static/media/close.61df3149.svg";